/** Source des données d'un compteur, déduite côté API du nom de fichier de sa structure CSV (onglet « Flux ») */
export enum Provider {
  DATALOGGER = "datalogger",
  MQTT = "mqtt",
  TETRAEDRE = "tetraedre",
  CLIMKIT = "climkit",
  METEO = "meteo",
  CSV = "csv",
  NONE = "none",
}

export const ProviderLabel: Record<Provider, string> = {
  [Provider.MQTT]: 'Sondes MQTT',
  [Provider.DATALOGGER]: 'Datalogger ESP32',
  [Provider.TETRAEDRE]: 'Tetraedre',
  [Provider.CLIMKIT]: 'Climkit',
  [Provider.METEO]: 'Météo',
  [Provider.CSV]: 'Fichier CSV',
  [Provider.NONE]: 'Aucune source',
};
